<h4 class="m-0 text-lg font-bold text-word-mark-800">
  {{ 'Absence type distribution' | translate }}
</h4>
<p class="text-sm font-semibold text-grey-500">{{ startDate }} - {{ endDate }}</p>
<content-state [isLoading]="loading">
  <sb-horizontal-stacked-bar-chart [items]="timeDistributionItems" [restItem]="hoursWorkedItem">
  </sb-horizontal-stacked-bar-chart>
</content-state>
